export class SearchResponseModel<T> {
  Total = 0;
  Page: number;
  Results = new Array<T>();
  length: number;
}
